let idCounter = 0;
export const uniqueId = (prefix = '') => { idCounter += 1; return `${prefix}${idCounter}`; };
export function getCookie(name) {
    let cookieValue = '';
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i += 1) {
            const cookie = cookies[i].trim();
            // Does this cookie string begin with the name we want?
            if (cookie.substring(0, name.length + 1) === `${name}=`) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}
export const breakpoints = {
    screen_med_xs: 569,
    screen_xs: 768,
    screen_md: 940,
    screen_lg: 1144,
};
export function validateEmail(email) {
    return email.match(/^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/);
}
export function numberFormat(value) {
    return new Intl.NumberFormat('en-US', {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
    }).format(value);
}
export function cleanSearch(searchString) {
    let search = '';
    if (searchString !== '') {
        const newString = searchString.split('?');
        [, search] = newString;
        const hashArr = search.split('&');
        hashArr.forEach((item, i) => {
            if (item.indexOf('page=') !== -1) {
                hashArr.splice(i, 1);
            }
        });
        if (hashArr.length === 0) {
            return '';
        }
        hashArr.forEach((item, i) => {
            if (i === 0) {
                search = item;
            }
            else {
                search += `&${item}`;
            }
        });
    }
    return search;
}
export function getUrlQuery(urlQuerystring) {
    const query = urlQuerystring.split('?')[1];
    const params = Object.fromEntries(new URLSearchParams(query));
    if ('names' in params) {
        return `names=${params.names}`;
    }
    if ('attribute' in params && 'val' in params) {
        return `attribute=${params.attribute}&val=${params.val}`;
    }
    if ('attribute_slug' in params && 'val_slug' in params) {
        return `attribute_slug=${params.attribute_slug}&val_slug=${params.val_slug}`;
    }
    if ('tags' in params) {
        return `tags=${params.tags}`;
    }
    if ('raw' in params) {
        return `raw=${params.raw}`;
    }
    if ('nurseries' in params) {
        return `nurseries=${params.nurseries}`;
    }
    if ('genus' in params) {
        return `genus=${params.genus}`;
    }
    if ('all_plants' in params) {
        return `all_plants=${params.all_plants}`;
    }
    const hashArr = query.split('&');
    return hashArr[0];
}
export function resetParam(queryStringToReset, param, value) {
    let newString = '';
    const params = queryStringToReset.split('&');
    if (queryStringToReset.indexOf(param) !== -1 && value) {
        // only add non-duplicates to new array
        let newArray = [];
        newArray = params.map((item) => {
            if (item.indexOf(param) === -1) {
                return item;
            }
            return `${param}=${value}`;
        });
        // create new query string
        newArray.forEach((item, i) => {
            if (i === 0) {
                newString += item;
            }
            else {
                newString += `&${item}`;
            }
        });
        return newString;
    }
    if (!value) {
        // remove query
        // only add non-duplicates to new array
        const newArray = [];
        params.forEach((item) => {
            if (item.indexOf(param) === -1) {
                newArray.push(item);
            }
        });
        // add values to searchString
        newArray.forEach((item, i) => {
            if (i === 0) {
                newString += item;
            }
            else {
                newString += `&${item}`;
            }
        });
        return newString;
    }
    if (queryStringToReset === '') {
        newString = `${param}=${value}`;
        return newString;
    }
    // if not a duplicate, just add the query to the existing queryString
    newString = `${queryStringToReset}&${param}=${value}`;
    return newString;
}
export function newSearchPath(path, search, number) {
    let searchString = '';
    if (number === 1) {
        searchString = resetParam(search, 'page', false);
    }
    else {
        searchString = resetParam(search, 'page', number);
    }
    if (path.length - 1 === path.lastIndexOf('/')) {
        return `${path}?${searchString}`;
    }
    return `${path}/?${searchString}`;
}
export function getQuery(query, queryType) {
    // format search terms for API
    let searchParams;
    const cleanQuery = encodeURIComponent(query.trim());
    const cleanQueryType = encodeURIComponent(queryType.trim());
    switch (queryType) {
        case 'Plant name':
            searchParams = `names=${cleanQuery}`;
            break;
        case 'Flower Color':
        case 'Plant Type':
        case 'Foliage Color':
        case 'Soil Needs':
        case 'Water Needs':
        case 'Wildlife':
        case 'Fruit':
        case 'Special Situation':
        case 'Sun Exposure':
        case 'Flower Season':
        case 'Texture':
        case 'Foliage Season':
            searchParams = `attribute=${cleanQueryType}&val=${cleanQuery}`;
            break;
        case 'Tags':
            searchParams = `tags=${cleanQuery}`;
            break;
        case 'Nursery':
            searchParams = `nurseries=${cleanQuery}`;
            break;
        case 'Genus':
            searchParams = `genus=${cleanQuery}`;
            break;
        case 'all_plants':
            searchParams = 'all_plants=True';
            break;
        case null:
            searchParams = '';
            break;
        default:
            searchParams = `raw=${cleanQuery}`;
    }
    // exception for when the user hits the search btn without entering anything
    if (query === 'all plants' && queryType === 'raw') {
        searchParams = 'all_plants=True';
    }
    return searchParams;
}
// Merge two arrays taking one element from each array by order and returning a new array.
export function mergeArrays(arr1, arr2) {
    const merged = [];
    const len = Math.max(arr1.length, arr2.length);
    for (let i = 0; i < len; i += 1) {
        if (i < arr1.length) {
            merged.push(arr1[i]);
        }
        if (i < arr2.length) {
            merged.push(arr2[i]);
        }
    }
    return merged;
}
export function cumulativeOffset(element) {
    let top = 0;
    let left = 0;
    let newElement = element;
    do {
        top += newElement.offsetTop || 0;
        left += newElement.offsetLeft || 0;
        newElement = newElement.offsetParent;
    } while (newElement);
    return {
        top,
        left,
    };
}
export const setMetaPropData = (property, value) => {
    const element = window.document.querySelector(`meta[property="${property}"]`);
    if (element) {
        element.content = value;
    }
    else {
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const newElement = document.createElement('meta');
        newElement.setAttribute('property', property);
        newElement.content = value;
        document.getElementsByTagName('head')[0].appendChild(newElement);
    }
};
export const setMetaNameData = (property, value) => {
    // eslint-disable-next-line @typescript-eslint/dot-notation
    const element = document.getElementsByTagName('meta')[property];
    // Create a temporary element to extract text content
    const tempElement = document.createElement('div');
    tempElement.innerHTML = value;
    const textContent = tempElement.textContent || tempElement.innerText || '';
    if (element) {
        element.content = textContent;
    }
    else {
        const newElement = document.createElement('meta');
        newElement.setAttribute('name', property);
        newElement.content = textContent;
        document.getElementsByTagName('head')[0].appendChild(newElement);
    }
};
export const isPDPPage = () => {
    const numberPattern = /^\d+/;
    if (typeof window !== 'undefined' && window.location.pathname.includes('/plants/')) {
        const urlType = window.location.pathname.split('/plants/')[1];
        return numberPattern.test(urlType);
    }
    return false;
};
